import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Plus, ArrowRight } from 'lucide-react';

/**
 * Amber alert banner shown to organizers when teams have been added AFTER pools
 * were generated but BEFORE the knockout has started. Clicking it opens the
 * Expand Bracket dialog so the organizer can absorb the late entries without
 * losing completed pool matches.
 *
 * Props:
 *   - orphanTeamIds: string[]  team_ids that aren't placed in any pool yet
 *   - onExpand:      () => void  opens the Expand Bracket dialog
 */
export default function ExpandBracketBanner({ orphanTeamIds, onExpand }) {
  return (
    <Card
      className="border-amber-400/40 bg-gradient-to-br from-amber-500/10 to-transparent"
      data-testid="expand-bracket-banner"
    >
      <CardContent className="p-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-amber-500/15 flex items-center justify-center flex-shrink-0">
          <Plus className="h-5 w-5 text-amber-400" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm">
            {orphanTeamIds.length} new {orphanTeamIds.length === 1 ? 'team needs' : 'teams need'} to be added to the bracket
          </div>
          <div className="text-xs text-muted-foreground mt-0.5">
            Completed pool matches will be preserved. New matches will be created for the new teams only.
          </div>
        </div>
        <Button
          onClick={onExpand}
          className="bg-amber-500 hover:bg-amber-600 text-black"
          data-testid="open-expand-dialog"
        >
          <ArrowRight className="h-4 w-4 mr-1.5" />
          Expand Bracket
        </Button>
      </CardContent>
    </Card>
  );
}
